import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	datetimeDefaultValueLabel: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.datetime.default-value.datetime-default-value-label',
		defaultMessage: 'Set to current time by default',
		description:
			'Label next to the checkbox that enables user to set default value to current time',
	},
	datetimeDefaultValueDisabledTooltip: {
		id: 'issue-type-page.field-associated.field-configuration.datetime.default-value.datetime-default-value-disabled-tooltip',
		defaultMessage: 'You can’t change this field’s default time',
		description: 'Tooltip shown when the default datetime field is disabled and cannot be edited',
	},
});
